import { getEnvironment } from 'config'

export const isServerSide = typeof window === 'undefined'
export const isProduction = () => getEnvironment() === 'prod'
export const isDevelopment = () => getEnvironment() === 'dev'
